import { Action } from '@ngrx/store';

export const RESET_STATE = '[RESET] Reset state';

export class RequestStateReset implements Action {
  readonly type = RESET_STATE;
}
